$("._tab").click(function() {
    let parentBlock = $(this).parents("._tabs-parent")
    let tabId = $(this).attr("data-tab")
    $(parentBlock).find("._tab").removeClass("_active")
    $(this).addClass("_active")
    $(parentBlock).find(".tab-content").removeClass("_active")
    $(parentBlock).find(`.${tabId}`).addClass("_active")
})

$(".footer-nav__top").click(function() {
    if(window.innerWidth>576){
        return
    }
    $(this).parents(".footer-nav").toggleClass("_open")
    $(this).siblings(".footer-nav__bottom").slideToggle()
})

$(".qa-card__show").click(function() {
    $(this).parents(".qa-card").toggleClass("_open")
    $(this).siblings(".qa-card__hidden").slideToggle()
})

$(".filter-group__top").click(function() {
    $(this).parents(".filter-group").toggleClass("_open")
    $(this).siblings(".filter-group__bottom").slideToggle()
})

$(".favourite-btn,.compare-btn").click(function() {
    $(this).toggleClass("_added")
})

$("._toggle-product-add-cart").click(function() {
    $(this).parents(".product-card").toggleClass("_added-to-cart")
})

$("._toggle-more").click(function() {
    $(this).parents("._toggle-more-parent").toggleClass("_show-all")
})

$(".scroll-top").click(function () {
    $(window).scrollTop(0);
})

$(".sort__current").html($(".sort__item input:checked").attr("data-value"))

$(".sort__item input").change(function () {
    let val = $(this).attr("data-value")
    $(".sort__current").html(val)
    $(".sort").removeClass("_open")
    $(".sort__hidden").slideUp()
})

$(".sort__show").click(function() {
    $(this).parents(".sort").toggleClass("_open")
    $(this).siblings(".sort__hidden").slideToggle()
})
